module.exports = __webpack_public_path__ + "static/media/coins.70b537b3.svg";